import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  constructor(public http: HttpClient) { }

  classReport(data){
    return this.http.post<any>("/edozzier/portal-classReport.php", data);
  }

  classTotalReport(data){
    return this.http.post<any>("/edozzier/portal-classTotalReport.php", data);
  }
  
  classTotalTermReport(data){
    return this.http.post<any>("/edozzier/portal-classTotalTermReport.php", data);
  }

  classTermReport(data){
    return this.http.post<any>("/edozzier/portal-classTermReport.php", data);
  }

  getComments() {
    return this.http.get<any>("/edozzier/portal-getComments.php");
  }

  ResultEntrySettings(data = {}){
    return this.http.post<any>('/edozzier/portal-resultEntrySettings.php', data);
  }

  getTermSettings(){
    return this.http.get<any>('/edozzier/portal-getTermSettings.php');
  }

  reportKeyGrades(data: any) {
    return this.http.post<any>("/edozzier/portal-report-keyGrades.php", data);
  }

  joinVirtualClass(data: any){
    return this.http.post<any>("/edozzier/portal-joinVirtualClass.php", data);
  }

  loadVirtualClasses(data: any){
    return this.http.post<any>("/edozzier/portal-loadVirtualClasses.php", data);
  }

}
